/**
 * SeriesManagerDialog Component
 * Dialog for managing aluminum series - add/delete custom series
 * Extracted from App.js to reduce main file complexity
 */
import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

// Default series that cannot be deleted
const DEFAULT_SERIES = [
  "Serie 20", "Serie 25", "Serie 30", "Serie 35", 
  "Serie 40", "Serie 45", "Serie 50", "Otra"
];

const SeriesManagerDialog = ({
  isOpen,
  onClose,
  aluminumSeries = [],
  newSeriesName,
  setNewSeriesName,
  onAddSeries,
  onDeleteSeries
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onAddSeries();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Gestionar Series de Aluminio</DialogTitle>
          <DialogDescription>
            Agrega o elimina series personalizadas para tus cotizaciones
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          {/* Add new series */}
          <div className="flex gap-2">
            <Input
              data-testid="new-series-input"
              placeholder="Nombre de nueva serie (ej: Serie 60)"
              value={newSeriesName}
              onChange={(e) => setNewSeriesName(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Button onClick={onAddSeries} data-testid="add-series-submit">
              <Plus className="w-4 h-4" />
            </Button>
          </div>
          
          {/* List current series */}
          <div className="border rounded-sm">
            <div className="p-3 bg-slate-50 border-b">
              <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Series Actuales
              </span>
            </div>
            <ScrollArea className="h-[200px]">
              <div className="divide-y">
                {aluminumSeries.map((series) => {
                  const isDefault = DEFAULT_SERIES.includes(series);
                  return (
                    <div key={series} className="flex items-center justify-between px-3 py-2">
                      <span className="text-sm">{series}</span>
                      {isDefault ? (
                        <Badge variant="secondary" className="text-xs">Por defecto</Badge>
                      ) : (
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => onDeleteSeries(series)}
                          className="text-red-600 hover:text-red-700 h-7 px-2"
                          data-testid={`delete-series-${series}`}
                        >
                          <Trash2 className="w-3 h-3" />
                        </Button>
                      )}
                    </div>
                  );
                })}
              </div>
            </ScrollArea>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="secondary" onClick={() => onClose(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SeriesManagerDialog;
